import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function createProcess(token,params){

    return Api.post(REQUEST_URLS.COMPANY_APPROVAL.CREATE_PAYMENT,params,{
        headers:{
            'Authorization': 'Bearer ' + token
        }
    })
}
export default createProcess;